import { post, get } from 'utils/FetchAPI';

export const login = (data) => post('/auth/login', data)

export const accessDownload = () => get("/auth/access-download")

export const forgotPassword = (data) => post('/auth/forgot-password', {...data, language: localStorage.getItem("lang")})

export const resetPassword = (data) => post('/auth/reset-password', data)